module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "type-manager"
  }, [_c('div', {
    staticClass: "type-manager-new"
  }, [_c('div', {
    staticClass: "d-flex align-items-start"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_c('h6', [_vm._v(_vm._s(_vm.id ? 'Bewerk type' : 'Maak een nieuw type'))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.form.name ? _vm.form.name : 'Nieuw afspraak type'))])]), _vm._v(" "), (_vm.id) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "title": "Maak nieuw type"
    },
    on: {
      "click": _vm.createNewType
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reply"
  })]) : _vm._e(), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "outline-primary",
      "title": _vm.id ? 'Opslaan' : 'Maak aan'
    },
    on: {
      "click": function($event) {
        _vm.id ? _vm.update() : _vm.create()
      }
    }
  }, [(_vm.isUpdatingType || _vm.isCreatingType) ? _c('loader-spinner', {
    attrs: {
      "iscolor": "#F0F0F0",
      "show-spinner": true
    }
  }) : (_vm.id) ? _c('fa-icon', {
    attrs: {
      "icon": "save"
    }
  }) : _c('fa-icon', {
    attrs: {
      "icon": "plus"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "title": "Sluit"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "times"
    }
  })], 1)], 1), _vm._v(" "), _c('general-input', {
    attrs: {
      "label": "Titel",
      "placeholder": "Vul een titel in"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "type-manager-color-input mt-2"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Kleur")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.color),
      expression: "form.color"
    }],
    attrs: {
      "type": "color",
      "value": "#FFFFFF"
    },
    domProps: {
      "value": (_vm.form.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "color", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('general-input', {
    staticClass: "type-manager-email-note-input mt-2",
    attrs: {
      "label": "Inhoud email",
      "inputType": "textarea",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.email_note),
      callback: function($$v) {
        _vm.$set(_vm.form, "email_note", $$v)
      },
      expression: "form.email_note"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "type-manager-current mt-4"
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Huidige types")]), _vm._v(" "), _vm._l((_vm.calendarTypes), function(type) {
    return _c('calendar-type', {
      key: type.id,
      staticClass: "mb-3",
      attrs: {
        "calendarType": type
      },
      on: {
        "edit": _vm.editType,
        "deleted": _vm.deletedType
      }
    })
  }), _vm._v(" "), (!_vm.calendarTypes.length) ? _c('div', {
    staticClass: "type-manager-empty-types"
  }, [_vm._v("\n            Er zijn nog types aangemaakt.\n        ")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b7478b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Planning/TypeManager.vue
// module id = 1292
// module chunks = 1